import React from 'react';

import Component from '../../Component';
import { withUser } from '../../../HoCs';
import { h6, h5 } from '../../../resources/styles';
import { getImage } from '../../../resources/images';
import { merge } from '../../../utils';
import OYOLogo from '../../../resources/vectors/oyo';

class FewStepsAway extends Component {

    renderEarningPotential = () => {
        const potential = this.getEarningPotential();
        return potential ? <div style={styles.earning}>A few steps away from earning&nbsp;<span style={styles.earning_highlight}>{potential}</span>&nbsp;per annum</div>
            : <div style={styles.earning}>Join the network of &nbsp;<span style={styles.earning_highlight}>25000+</span>&nbsp;owners and maximise your earnings</div>;
    }

    render = () => <div style={merge(styles.container, this.props.style)} className={this.props.className}>
        <img src={getImage('coins-on-table.jpeg')} alt='coins-on-table' style={styles.image} />
        {this.renderEarningPotential()}
        <div style={styles.joinOyo}>Join&nbsp;<OYOLogo style={styles.OYO} />&nbsp;</div>
    </div>;

}

export default withUser(FewStepsAway);

const styles = {

    container: { height: 350, width: 700, position: 'relative', borderRadius: 10, overflow: 'hidden', boxShadow: 'var(--shadow-dark)' },

    image: { height: '100%', width: '100%', objectFit: 'cover' },

    earning: { ...h6, textAlign: 'center', padding: '16px 32px', position: 'absolute', top: 0, backgroundColor: '#fff5' },

    earning_highlight: { ...h5, color: 'var(--theme-color)' },

    joinOyo: { ...h6, padding: 16, position: 'absolute', bottom: 0, right: 0, boxSizing: 'border-box' },

    OYO: { position: 'relative', top: 2 },

};